import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const monthNames = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/** Build chart data from raw call counts (month + callCount). Parent is responsible for fetching. */
function buildChartData(callCountsData) {
  const now = new Date();
  const last6Months = [];
  for (let i = 5; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    last6Months.push({
      monthKey: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`,
      monthLabel: `${monthNames[d.getMonth()]} ${d.getFullYear()}`,
      calls: 0,
    });
  }
  (callCountsData || []).forEach((item) => {
    const monthObj = last6Months.find((m) => m.monthKey === item.month);
    if (monthObj) monthObj.calls = item.callCount;
  });
  return last6Months;
}

const BillingsGraph = ({ callCountsData = [], loading = false, errorMsg = "" }) => {
  const chartData = useMemo(
    () => buildChartData(callCountsData),
    [callCountsData]
  );

  if (loading) return <div>Loading chart...</div>;
  if (errorMsg) return <div className="text-red-500">{errorMsg}</div>;

  return (
    <div style={{ width: "100%", height: 400 }}>
      <ResponsiveContainer>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid
            horizontal={true}
            vertical={false}
            strokeDasharray="3 3"
          />
          <XAxis
            dataKey="monthLabel"
            tickMargin={0} // Reduce margin for ticks
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            allowDecimals={false}
            label={{ angle: -90, position: "insideLeft" }}
            tickMargin={0} // Reduce margin for ticks
            axisLine={false}
            tickLine={false}
          />
          <Tooltip />
          <Bar
            dataKey="calls"
            fill="#4F46E5"
            barSize={100}
            radius={[10, 10, 0, 0]} // top-left, top-right, bottom-right, bottom-left
            isAnimationActive={false} // disables hover color animation
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BillingsGraph;
